import { render, staticRenderFns } from "./jointPreferencesCourseCard.vue?vue&type=template&id=425148cc&scoped=true&"
import script from "./jointPreferencesCourseCard.vue?vue&type=script&lang=js&"
export * from "./jointPreferencesCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./jointPreferencesCourseCard.vue?vue&type=style&index=0&id=425148cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425148cc",
  null
  
)

export default component.exports